class QuickAddModal extends HTMLElement {
    constructor() {
        super();
    }

    show() {
        this.setAttribute('open', '');
        document.body.classList.add('overflow-hidden');
    }

    close() {
        this.removeAttribute('open');
        document.body.classList.remove('overflow-hidden');
    }
}

if (!customElements.get("quick-add-modal")) {
    customElements.define("quick-add-modal", QuickAddModal);
}

function show(opener) {
    if (!opener) return; // ✅ Prevent errors if no opener
    opener.setAttribute("aria-disabled", true);
    opener.classList.add("loading");

    const spinner = opener.querySelector(".loading-overlay__spinner");
    if (spinner) spinner.classList.remove("hidden");

    const productUrl = opener.getAttribute("data-product-url");
    if (!productUrl) {
        console.error("❌ Quick View Error: Missing data-product-url.");
        return; // ✅ Return if productUrl is missing
    }

    // Continue the rest of the logic...
    fetch(productUrl)
        .then((response) => {
            if (!response.ok) throw new Error("Failed to load product");
            return response.text();
        })
        .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, "text/html");
            this.productElement = responseHTML.querySelector('div[id^="MainProduct-"]');

            if (!this.productElement) {
                console.error("❌ Quick View Error: Could not find product container.");
                return;
            }

            preventDuplicatedIDs(this.productElement);
removeDOMElements(this.productElement);

const modalContent = document.querySelector(".quick-add-modal .modal__content");
setInnerHTML(modalContent, this.productElement.innerHTML, opener);

            // Additional logic...
        })
        .catch((error) => {
            console.error("❌ Quick View Error:", error); // Handle the error here
        })
        .finally(() => {
            opener.removeAttribute("aria-disabled");
            opener.classList.remove("loading");
            if (spinner) spinner.classList.add("hidden");

            // Continue with any other logic after the fetch is completed
        });
}

						// ✅ Check if Swiper container exists before initializing
						const swiperContainer = document.querySelector(".quick-add-modal .quick-js-media-list");
						if (swiperContainer) {
							new Swiper(swiperContainer, {
								slidesPerView: 1,
								autoHeight: true,
								navigation: {
									nextEl: ".swiper-btn--next",
									prevEl: ".swiper-btn--prev",
								},
								pagination: {
									el: ".quick-add-modal .swiper-pagination",
									type: "fraction",
									formatFractionCurrent: (num) => `0${num}`.slice(-2),
									formatFractionTotal: (num) => `0${num}`.slice(-2),
								},
								on: {
									slideChange: function () {
										window.pauseAllMedia();
									},
								},
							});
						}

				// ✅ Fix: Ensure dropdown behavior works properly
				document.querySelectorAll(".product-form__controls--dropdown").forEach((dropdown) => {
					const selectLabel = dropdown.querySelector(".dropdown-select .select-label");
					const dropdownMenu = dropdown.querySelector(".dropdown-select ul");

					if (!selectLabel || !dropdownMenu) return;

					selectLabel.addEventListener("click", (e) => {
						e.stopPropagation();
						dropdownMenu.classList.toggle("active");
						document.addEventListener("click", () => dropdownMenu.classList.remove("active"), { once: true });
					});

					dropdownMenu.querySelectorAll("li").forEach((item) => {
						item.addEventListener("click", () => {
							selectLabel.querySelector("span").textContent = item.textContent;
							dropdownMenu.classList.remove("active");
						});
					});
				});
function setInnerHTML(element, html, opener) {
	if (!element) return;
	element.innerHTML = html;

	// ✅ Ensure scripts run correctly
	element.querySelectorAll("script").forEach((oldScript) => {
		const newScript = document.createElement("script");
		Array.from(oldScript.attributes).forEach((attr) => newScript.setAttribute(attr.name, attr.value));
		newScript.appendChild(document.createTextNode(oldScript.innerHTML));
		oldScript.parentNode.replaceChild(newScript, oldScript);
	});

	// ✅ Add "Read More" button inside Quick View
	const moreBtn = document.createElement("a");
	moreBtn.innerHTML = `<span class="button-label">${theme.quickviewMore || "View More"}</span>`;
	moreBtn.setAttribute("href", opener.getAttribute("data-product-url"));
	moreBtn.classList.add("product__read-more", "button", "button--simple");
	element.querySelector(".product__info-container")?.appendChild(moreBtn);
}

function removeDOMElements(productElement) {
	const selectorsToRemove = [
		"pickup-availability",
		"product-modal",
		".product-popup",
		'[data-block-handle="reviews"]',
		".product-about",
		".product__description",
		".product-recommendations--single",
		".customer",
		".product__left-wrapper",
		".product__media-sublist",
		".product__inventory",
		".product__text",
		".adv-btn-opener",
		".product__media-scroll-wrapper",
		".product__media-list-wrapper",
		".product__media-list__container--large-default",
		".quick-product__media-list",
	];

	selectorsToRemove.forEach((selector) => {
		const element = productElement.querySelector(selector);
		if (element) element.remove();
	});

	// ✅ Fix Quick View Media Display
	const mediaQuick = productElement.querySelector(".quick-product__media-list");
	if (mediaQuick) mediaQuick.style.display = "block";
}

function preventDuplicatedIDs(productElement) {
	const sectionId = productElement.dataset.section;
	if (!sectionId) return;

	productElement.innerHTML = productElement.innerHTML.replaceAll(
		sectionId,
		`quickadd-${sectionId}`
	);

	productElement.querySelectorAll("variant-selects, variant-radios").forEach((variantSelect) => {
		variantSelect.dataset.originalSection = sectionId;
	});
}

function preventVariantURLSwitching(modalContent) {
	const variantSelectors = modalContent.querySelector("variant-radios,variant-selects");
	if (variantSelectors) variantSelectors.setAttribute("data-update-url", "false");
}

function removeGalleryListSemantic(modalContent) {
	const galleryList = modalContent.querySelector('[id^="Slider-Gallery"]');
	if (!galleryList) return;

	galleryList.setAttribute("role", "presentation");
	galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute("role", "presentation"));
}

function updateImageSizes(modalContent) {
	const product = modalContent.querySelector(".product");
	if (!product || !product.classList.contains("product--columns")) return;

	const mediaImages = product.querySelectorAll(".product__media img");
	if (!mediaImages.length) return;

	const mediaImageSizes =
		"(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";
	mediaImages.forEach((img) => img.setAttribute("sizes", mediaImageSizes));
}

document.addEventListener("DOMContentLoaded", function () {
  const body = document.body;

  // Run this only on product pages or pages where quick-add is used
  if (!body.classList.contains("template-product") && !body.classList.contains("template-collection")) {
    return;
  }

  const closeButton = document.querySelector(".quick-add-modal .close-button");
  const modal = document.querySelector(".quick-add-modal");

  if (!closeButton || !modal) {
    console.warn("⚠️ Quick Add modal or close button not found, skipping.");
    return;
  }

  closeButton.addEventListener("click", function (event) {
    event.preventDefault();

    if (modal.hasAttribute("open")) {
      modal.removeAttribute("open");
      modal.style.display = "none";
      document.body.classList.remove("overflow-hidden");
      console.log("✅ Modal closed.");
    }
  });
});
